module.exports = "<div ng-class=\"{\n    container: !$$setting.data.general.checkboxs.largeMode.model,\n    largeContainer: $$setting.data.general.checkboxs.largeMode.model\n  }\">\n  <my-radio-menu my-menu=\"settingMenu\"\n    my-id=\"setting\">\n  </my-radio-menu>\n\n  <div class=\"line-separator\"></div>\n\n  <div ui-view>\n  </div>\n\n  <div class=\"line-separator\"></div>\n\n  <my-radio-menu my-menu=\"settingMenu\"\n    my-id=\"setting\">\n  </my-radio-menu>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/setting/templates/index.html
// module id = 1646
// module chunks = 0